/* eslint-disable react-hooks/exhaustive-deps */

import {useMutation, useQuery} from "@apollo/react-hooks";
import {makeStyles} from '@material-ui/core/styles';
import React, {useEffect, useState} from 'react';
import {notify} from "../../utils/notify";
import usePersistentStore from "../../persistentStore";
import {GET_USER, UPDATE_USER} from "../../database/queries/userQueries";
import Paper from "@material-ui/core/Paper";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import BackupOutlinedIcon from "@material-ui/icons/BackupOutlined";
import ClearIcon from "@material-ui/icons/Clear";
import Grid from "@material-ui/core/Grid";
import FormControl from "@material-ui/core/FormControl";
import TextField from "@material-ui/core/TextField";
// import {INTERNAL_PROJECT_IDS, INTERNAL_PROJECT_TASKS} from "../../database/queries/internalProjects";

const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
    },
    grow: {
        flexGrow: 1,
    },
    leftField: {
        paddingRight: 10
    },
    middleField: {
        paddingLeft: 10,
        paddingRight: 10,
    },
    rightField: {
        paddingLeft: 10,
    },
    gridContainer: {
        overflow: 'auto',
        overflowY: 'scroll',
        padding: 20,
    },
    noMargin: {
        marginBottom: 0,
        minHeight: 0
    },
}));

const Profile = props => {
    const classes = useStyles();
    const [userChanged, setUserChanged] = useState(false);
    const [updatedUser, setUpdatedUser] = useState();
    const [globalPersistentState, globalPersistentActions] = usePersistentStore();

    const {loading: getUserDataLoading, error: getUserDataError, data: getUserData, refetch: getUserDataRefetch} = useQuery(GET_USER, {
        variables: {
            userId: globalPersistentState.me && globalPersistentState.me.userId ? globalPersistentState.me.userId : '',
        },
    });

    // const {loading: getInternalProjectIdsLoading, error: getInternalProjectIdsError, data: getInternalProjectIdsData, refetch: getInternalProjectIdsRefetch} = useQuery(INTERNAL_PROJECT_IDS, {
    //     variables: {
    //         projectNames: ['JunctionBox Extension', 'JunctionBox Server', 'JunctionBox DB'],
    //     },
    // });
    //
    // const {loading: getInternalProjectTasksLoading, error: getInternalProjectTasksError, data: getInternalProjectTasksData, refetch: getInternalProjectTasksRefetch} = useQuery(INTERNAL_PROJECT_TASKS, {
    //     skip: !projectIds || projectIds.length === 0,
    //     variables: {
    //         projectIds: projectIds,
    //     },
    // });

    const [updateUser, {error: updateUserError}] = useMutation(UPDATE_USER);

    // useEffect(() => {
    //     if (getInternalProjectIdsData) {
    //         if (getInternalProjectIdsData.internalProjectIds.idList && getInternalProjectIdsData.internalProjectIds.idList.length > 0) setProjectIds(getInternalProjectIdsData.internalProjectIds.idList);
    //     }
    // }, [getInternalProjectIdsData]);
    //
    // useEffect(() => {
    //     if (projectIds && projectIds.length > 0) {
    //         getInternalProjectTasksRefetch()
    //     }
    // }, [projectIds]);

    useEffect(() => {
        setUpdatedUser({...globalPersistentState.me})
    }, [globalPersistentState.me]);

    useEffect(() => {
        if (getUserDataError) notify('getUserDataError', 'error', getUserDataError.message);
        if (updateUserError) notify('updateUserError', 'error', updateUserError.message);
    }, [getUserDataError, updateUserError]);

    useEffect(() => {
        if (getUserData && getUserData.user) {
            globalPersistentActions.setMe(getUserData.user);
            setUpdatedUser({...globalPersistentState.me});
            setUserChanged(false);
        }
    }, [getUserData]);

    const handleChange = (e) => {
        const tmpUser = {
            ...updatedUser,
            [e.target.name]: e.target.value
        };
        setUpdatedUser(tmpUser);
        setUserChanged(true);
    };

    if (getUserDataLoading) return <p>Loading ...</p>;
    if (getUserDataError) return `Error! ${getUserDataError.message}`;

    return (
        <form className={classes.root}>
            {updatedUser && (<Paper className={classes.textboxPaper}>
                <AppBar color="default" position="static" className={classes.noMargin}>
                    <Toolbar className={classes.noMargin}>
                        <div className={classes.grow}/>
                        {userChanged && <IconButton
                            aria-label="save user"
                            color="inherit"
                            size="small"
                            onClick={() => {
                                updateUser({
                                    variables: {
                                        changedUser: {
                                            userId: updatedUser.userId,
                                            displayName: updatedUser.firstName + ' ' + updatedUser.lastName,
                                            firstName: updatedUser.firstName,
                                            lastName: updatedUser.lastName,
                                            phoneNumber: updatedUser.phoneNumber,
                                        }
                                    }
                                }).then(function (updateResult) {
                                    getUserDataRefetch().then(() => {
                                        notify('updateUser', 'info', updatedUser.displayName + ' profile updated');
                                    });
                                })
                            }}>
                            <BackupOutlinedIcon/>
                        </IconButton>}
                        {userChanged && <IconButton
                            aria-label="cancel edit user"
                            color="inherit"
                            size="small"
                            onClick={() => {
                                setUpdatedUser({...globalPersistentState.me});
                                setUserChanged(false);
                            }}>
                            <ClearIcon/>
                        </IconButton>}
                    </Toolbar>
                </AppBar>
                <Grid container className={classes.gridContainer}>
                    <Grid item xs={3} className={classes.leftField}>
                        <FormControl
                            className={classes.formControl}
                            margin="dense"
                            size="small"
                            fullWidth
                        >
                            <TextField
                                fullWidth
                                id="firstName"
                                label="First name"
                                name="firstName"
                                onChange={handleChange}
                                required
                                size="small"
                                value={updatedUser.firstName}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={3} className={classes.rightField}>
                        <FormControl
                            className={classes.formControl}
                            margin="dense"
                            size="small"
                            fullWidth
                        >
                            <TextField
                                fullWidth
                                id="lastName"
                                label="Last name"
                                name="lastName"
                                onChange={handleChange}
                                placeholder="Last name"
                                required
                                size="small"
                                value={updatedUser.lastName}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={3} className={classes.middleField}>
                        <FormControl
                            className={classes.formControl}
                            margin="dense"
                            size="small"
                            fullWidth
                        >
                            <TextField
                                fullWidth
                                id="email"
                                label="Email Address"
                                name="email"
                                onChange={handleChange}
                                placeholder="Email Address"
                                size="small"
                                value={updatedUser.email}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={3} className={classes.rightField}>
                        <FormControl
                            className={classes.formControl}
                            margin="dense"
                            size="small"
                            fullWidth
                        >
                            <TextField
                                fullWidth
                                id="phoneNumber"
                                label="Phone Number"
                                name="phoneNumber"
                                onChange={handleChange}
                                placeholder="Phone Number"
                                size="small"
                                value={updatedUser.phoneNumber}
                            />
                        </FormControl>
                    </Grid>
                </Grid>
            </Paper>)}
        </form>
    )
};

export default Profile;
